export default __webpack_public_path__ + "static/media/voucher.097b4873.svg";